const getters = {
  user: state => state.user.user,
  platformList: state => state.user.platformList,
  addressType: state => state.user.addressType,
  addressId: state => state.user.addressId,
  activityForm: state => state.user.activityForm
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js